import styled from "styled-components";

export const HomeStyled = styled.main`
  height: 100%;
  width: 100%;
  position: relative;
`;
